export enum DashboardPermissions {
  ALL = "Travel:Dashboard:*",
  READ = "Travel:Dashboard:Read",
}

export function hasDashboardAccess(userPermissions: string[]): boolean {
  return userPermissions.some((p) =>
    [DashboardPermissions.ALL, DashboardPermissions.READ, "*"].includes(
      p as DashboardPermissions | "*"
    )
  );
}
